import { getSiloKeyFromWindowUrl, getThemeFromWindowUrl } from 'platform-specific/url';
import { getDeploymentConfig } from 'util/util';

import type { Theme } from './types';
import { zdfThemeNames, zdfThemes } from './zdf/zdf-themes';

const themeNames = [...zdfThemeNames];
export type ThemeName = (typeof themeNames)[number];

const themes: Record<ThemeName, Theme> = {
    ...zdfThemes,
};

export default themes;

export function getThemeKey(): ThemeName | null {
    const deploymentConfig = getDeploymentConfig();
    const siloKeyUrl = getSiloKeyFromWindowUrl();
    const siloConfig = deploymentConfig?.siloConfig?.[siloKeyUrl];
    const siloThemeKey = siloConfig?.themeKey;
    const urlParamThemeKey = getThemeFromWindowUrl();
    const retrievedThemeKey = urlParamThemeKey ?? siloThemeKey ?? '';
    // Make sure that the provided theme exists
    return themeNames.includes(retrievedThemeKey as ThemeName) ? (retrievedThemeKey as ThemeName) : null;
}

/** Returns the specified theme or the current theme if no key specified*/
export function getTheme(themeKey?: ThemeName): Theme | null {
    if (!themeKey) {
        const currentThemeKey = getThemeKey();
        return currentThemeKey ? themes[currentThemeKey] : null;
    }
    return themes[themeKey];
}
